export default __webpack_public_path__ + "static/media/img-0029.d19a0c3c.png";